export const getTotalCasesCount = (items, rounding) => {
  if (!items || items.length === 0) return 0;

  const poField = rounding ? "quantityOrderedRounded" : "quantityOrdered";
  return items.reduce((total, item) => {
    const cases = Number(item[poField]) || 0;
    return total + cases;
  }, 0);
};

export const getTotalPalletCount = (items, isRounding) => {
  if (!items || items.length === 0) return 0;

  const poField = isRounding ? "palletQuantityRounded" : "palletQuantity";
  const sum = items.reduce((total, item) => {
    const pallets = Number(item[poField]) || 0;
    return total + pallets;
  }, 0);

  return Number(sum.toFixed(2));
};

export const getTotalBasesCount = (items) => {
  if (!items || items.length === 0) return 0;

  const poField = "palletQuantityRounded";
  const sum = items.reduce((total, item) => {
    const pallets = Number(item[poField]) || 0;
    return total + pallets;
  }, 0);

  return Math.ceil(sum);
};

export const getTotalWagonsCount = (items, isRounding) => {
  if (!items || items.length === 0) return 0;

  const poField = isRounding ? "palletQuantityRounded" : "palletQuantity";
  const sum = items.reduce((total, item) => {
    const pallets = Number(item[poField]) || 0;
    return total + pallets;
  }, 0);

  return items.length > 0 ? Math.ceil(sum / items[0].palletPerWagon) || 0 : 0;
};
